import FactoryOut from './factory_out.vue';

export default FactoryOut;
